// Custom JavaScript for site-wide functionality

// Function to verify specific products by ID
function checkSpecificProducts() {
  try {
    // Find all elements with data-product-id
    const productElements = document.querySelectorAll('[data-product-id]');
    
    // If no product elements found, exit gracefully
    if (!productElements || productElements.length === 0) {
      return;
    }
    
    // Specific product IDs we want to check
    const targetProductIds = ['14922297147769', '14925744177529'];
    
    // Check each element
    productElements.forEach(element => {
      try {
        // Safely get product ID, if attribute doesn't exist, use empty string
        const productId = element && element.getAttribute ? element.getAttribute('data-product-id') || '' : '';
        
        // Check if the ID matches any of the target IDs
        if (productId && targetProductIds.includes(productId)) {
          
          try {
            // Hide the requested elements
            const elementsToHide = [
              '.product--customer-reviews',
              '.junip-product-review',
              '.so-many-dishes-section',
              '#headingsix'
            ];
            
            // Loop through the list of elements and hide them
            elementsToHide.forEach(selector => {
              try {
                if (!selector) return; // Skip empty selectors
                
                const elements = document.querySelectorAll(selector);
                if (elements && elements.length > 0) {
                  elements.forEach(el => {
                    if (el && el.style) {
                      el.style.display = 'none';
                    }
                  });
                } else {
                }
              } catch (selectorError) {
                console.error('Error hiding element with selector ' + selector + ':', selectorError);
              }
            });
            
            // Hide all <a> elements inside #collapsefive-mobile and #collapsefive
            const collapseElements = ['#collapsefive-mobile', '#collapsefive'];
            
            collapseElements.forEach(collapseId => {
              try {
                if (!collapseId) return; // Skip empty selectors
                
                const collapseElement = document.querySelector(collapseId);
                if (collapseElement) {
                  const linkElements = collapseElement.querySelectorAll('a');
                  if (linkElements && linkElements.length > 0) {
                    linkElements.forEach(link => {
                      if (link && link.style) {
                        link.style.display = 'none';
                      }
                    });
                  } else {
                  }
                } else {
                }
              } catch (collapseError) {
                console.error('Error processing collapse element ' + collapseId + ':', collapseError);
              }
            });
          } catch (hideError) {
            console.error('Error in hiding elements:', hideError);
          }
        } else {
        }
      } catch (productError) {
        console.error('Error processing product element:', productError);
      }
    });
  } catch (error) {
    console.error('Error in checkSpecificProducts function:', error);
  }
}


const checkBurleighPDP = () => {
  var body = document.body;
    if (body.classList.contains('template-product-gymkhana-x-burleigh')) {
      body.classList.add('template-product-bundle-product');
    }
}

const checkSmartCart = () => {
  const body = document.body;

  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        if (body.classList.contains('smart-cart--enabled')) {
          setTimeout(function() {
            body.classList.remove('overflow-hidden');
          }, 100);
        }
      }
    });
  });

  const config = { attributes: true };
  observer.observe(body, config);
}


document.addEventListener('DOMContentLoaded', function() {
  // Run the function when the page is loaded

  checkBurleighPDP();
  checkSpecificProducts();
  checkSmartCart();

}); 